<template>
    <div>
        <div id="PGWHPCACCTContainer2"></div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            };
        },
        mounted() {
            const SALT = 'JnRp1fTzWEM=';
            function changeDateFormat() {
                Date.prototype.yyyymmdd = function () {
                    function pad2(n) {
                        return (n < 10 ? "0" : "") + n;
                    }

                    return [this.getFullYear(),
                        pad2(this.getMonth() + 1),
                        pad2(this.getDate()),
                        pad2(this.getHours()),
                        pad2(this.getMinutes()),
                        pad2(this.getSeconds())].join("");
                };
            }

            changeDateFormat();

            let date = new Date();
            let expDate = new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000).yyyymmdd();
            console.log("DateTime: " + date.yyyymmdd());
            console.log("Expiry DateTime: " + expDate);
            let txnRefNo = ["T", date.yyyymmdd()].join("");

            //Update transaction parameters
            PGWHPCTransactionParameters.__00amt__ = "3500"; //pp_Amount
            PGWHPCTransactionParameters.__01brn__ = "billref";//new Date().getTime().toString(); //pp_BillReference
            PGWHPCTransactionParameters.__02des__ = "Headphones"; //pp_Description
            PGWHPCTransactionParameters.__03lan__ = "EN";  //pp_Language
            PGWHPCTransactionParameters.__04mid__ = "mesum3"; //pp_MerchantID
            PGWHPCTransactionParameters.__05pwd__ = "mesum3"; //pp_Password
            PGWHPCTransactionParameters.__06url__ = "https://172.16.227.31:444/MerchantSimulatorPGW/HttpRequestDemoServer/Index"; //pp_ReturnURL
            PGWHPCTransactionParameters.__07smid__= ""; //pp_SubMerchantID
            PGWHPCTransactionParameters.__08seh__ = SALT; //pp_SecureHash
            PGWHPCTransactionParameters.__09cur__ = "PKR"; //pp_TxnCurrency
            PGWHPCTransactionParameters.__10tdt__ = date.yyyymmdd(); //pp_TxnDateTime
            PGWHPCTransactionParameters.__11edt__ = expDate; //pp_TxnExpiryDateTime
            PGWHPCTransactionParameters.__12trn__ = txnRefNo; //pp_TxnRefNo
            PGWHPCTransactionParameters.__13ver__ = "1.1"; //pp_Version
            //PGWHPCTransactionParameters.__14fbu__ = "";

            delete PGWHPCTransactionParameters.__08seh__; //pp_SecureHash

            var keys = Object.keys(PGWHPCTransactionParameters).sort(function (a, b) {
                if (a.toLowerCase() < b.toLowerCase()) return -1;
                if (a.toLowerCase() > b.toLowerCase()) return 1;
                return 0;
            });
            var message = "";
            keys.forEach(key => { message += PGWHPCTransactionParameters[key] ? [PGWHPCTransactionParameters[key], '&'].join("") : "" })
            message = [SALT, "&", message.slice(0, -1)].join("");

            // calculate secureHash
            var hash = CryptoJS.HmacSHA256(message, SALT);

            PGWHPCTransactionParameters.__08seh__ = hash.toString().toUpperCase();

            //Initialize
            document.addEventListener("DOMContentLoaded", function (event) {
                PGWHPCAcct.initialize("PGWHPCACCTContainer2"); //Render Account Fields
            });

            PGWHPCSuccessMap.onPurchaseProcessedViaAccount = function (msg) {
                //alert("purchase done - Account");
                console.log("purchase done - Account");
                console.log(msg);
                //Your code to handle this success message
            }

            //Error Code Mappings
            PGWHPCErrorMap.onInvalidTransactionDetails = function (msg) {
                //alert("Invalid Transaction Details");
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onInvalidContainerArea = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onInvalidCNIC = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onInvalidContact = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onInvalidBank = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onInvalidAccount = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onInvalidOTP = function (msg) {
                alert("Invalid OTP")
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onRequestTimedOut = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onSystemError = function (msg) {
                console.log(msg);
                //Your code to handle this error
            }

            PGWHPCErrorMap.onGenericError = function (msg) {
                alert('Error')
                console.log(msg);
                //Your code to handle this error
            }


            var gearPage = document.getElementById('GearPage');
            if(null != gearPage)
            {
                gearPage.parentNode.removeChild(gearPage);
                document.title = "Error";
            }

        },
        methods: {

        }
    }
</script>